import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <>
      <div style={{backgroundColor: 'black'}} >
        <div className="wrapper">
      <a href="https://twitter.com/vaibhavraj524" className="icon twitter"
        ><i className="fab fa-twitter"></i
      ></a>

      <a href="https://www.linkedin.com/in/vaibhav-raj-alpha/" className="icon linkedin"
        ><i className="fab fa-linkedin"></i
      ></a>
      <a href="https://github.com/vaibhav-raj" className="icon github"
        ><i className="fab fa-github"></i
      ></a>
    </div>
        <div style={{color: 'white', marginLeft:'10px'}} >Created By Vaibhav Raj | © 2021. All Rights Reserved</div>
      </div>    
    </>
  );
};

export default Footer;
